import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance, initializeMsal } from './config/msalConfig';
import App from './App';
import './index.css';
import * as Sentry from '@sentry/react';

// Initialise Sentry before the first render so all errors — including those thrown
// during MSAL initialisation — are captured.  DSN is injected at build time via the
// VITE_SENTRY_DSN environment variable; if absent (local dev without .env) Sentry
// is effectively a no-op.
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,           // 'development' | 'production'
  // Capture 100 % of transactions in dev; dial down to ~10 % in production once
  // you've confirmed it's working.
  tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
  // Session Replay — records what the user was doing when an error occurred.
  // PII masking is ON by default (all text replaced with asterisks, images blocked).
  replaysSessionSampleRate: 0.0,  // only record on errors, not every session
  replaysOnErrorSampleRate: 1.0,  // 100 % of sessions with an error get a replay
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // PII masking — defaults are already safe; explicit here for audibility.
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
});

// Initialise MSAL (handles the redirect response on return from sign-in) before rendering,
// mirroring CustomerSuccessPortal. Render regardless so auth errors degrade gracefully.
initializeMsal().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
});
